import { LOCALES } from 'i18n/locales';

export const loadingIntl = {
    [LOCALES.ENGLISH]: {
        'Loading.title': 'Loading'

    },
    [LOCALES.WELSH]: {
        'Loading.title': 'Wrthi\'n Llwytho'
    }
};
